<template>
  <div>
    <div class="header">
      <img
        class="pic1"
        referrerpolicy="no-referrer"
        src="/icon/reg/r2.png"
      />
      <span class="word2">请确认服务协议。</span>
    </div>
    <a-form-item :span="24">
      <div class="textarea">
        <div class="text"><Defalut></Defalut></div>
      </div>
    </a-form-item>

    <div class="bd5 flex-row">
      <a-checkbox :defaultChecked="this.agreement" @change="agree">
        <span class="word3">我已阅读并接受以上服务条款</span>
      </a-checkbox>
    </div>
    <div class="outer9 flex-col"></div>
    <a-col :span="12">
      <a-form-item :wrapper-col="{ span: 12, offset: 16 }">
        <a-button class="button" @click="last" type="primary" ghost>
          上一步
        </a-button>
      </a-form-item>
    </a-col>

    <a-col :span="12">
      <a-form-item :wrapper-col="{ span: 10, offset: 0 }">
        <a-button
          @click="next"
          class="button"
          type="primary"
          html-type="submit"
          :disabled="!this.agreement"
        >
          下一步
        </a-button>
      </a-form-item>
    </a-col>
  </div>
</template>
<script>
import Defalut from '../../../components/Agreement/Default.vue'
export default {
  data() {
    return {
      agreement: this.$store.state.register.form.agreement,
    }
  },
  components: {
    Defalut,
  },
  methods: {
    next() {
      this.$emit('nextStep', 1)
      this.$store.commit('register/changeAgreement', this.agreement)
    },
    last() {
      this.$emit('lastStep', 1)
    },
    agree() {
      this.agreement = !this.agreement
      console.log(this.agreement)
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  margin: 13px 0 0 6px;
}
.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}

.word2 {
  z-index: 11;
  width: 128px;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 22px;
  text-align: left;
  margin-top: 14px;
  margin-left: 23px;
}

.bd3 {
  z-index: auto;
  width: 100%;
  height: 326px;
  justify-content: space-between;
  margin: 38px 120px 152px 30px;
  background: #fcfcfc;
}
.textarea {
  height: 329px;
  // width: 850px;
  background-color: #fcfcfc;
  margin-top: 18px;
  padding: 26px 40px 26px 32px;
  overflow-y: scroll;
}

.textarea::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}

.textarea::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #f5f5f5;
}

.textarea::-webkit-scrollbar-thumb {
  /*width: 10px;*/
  border-radius: 4px;
  background-color: #c6c6c6;
}

.bd5 {
  z-index: auto;
  width: 100%;
  height: 22px;
  line-height: 22px;
  justify-content: space-between;
  margin: 17px 0 0 30px;
}

.word3 {
  z-index: 12;
  display: inline-block;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  vertical-align: top;
  margin-left: 10px;
}
.button {
  width: 140px;
  height: 42px;
  border-radius: 4px;
  margin-top: 23px;
}
.outer9 {
  z-index: 37;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 40px;
}
</style>
